<template>
<div :class="['micad_formElement micad_formElement_checkbox',getType(type)]">
    <label class="micad_formElement_label">{{label}}</label>
    <div class="micad_formElement_control">
        <label v-for="item in items" :key="item" class="micad_formElement_control_label"><input type="checkBox" class="micad_formElement_control_input" />{{item}}</label>
    </div>
    <div class="micad_formElement_message">{{message}}</div>
</div>
</template>

<script>
export default {
  name: 'Check-box',
  data() {
    return {
        label: "Quisque tristique.",
        items: ["Item 1", "Item 2", "Item 3", "Item 4", "Item 5", "Item 6"],
        message: "Quisque tristique quis leo vitae luctus."
        }
    },
    props: {
        type: String,
    },
    methods: {
        getType(type) {
            if (type !== undefined) {
                return ' micad_formElement_'+type
            }
        }
    }
};
</script>
